import { Alert, styled } from '@mui/material';

export const UPAlertStyled = styled(Alert)(() => ({
  color: 'white',
  marginLeft: '80px',
  '& .MuiSvgIcon-root': {
    fill: 'white',
  },
}));
